<template>
    <div class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}">
        <div class="modal-main">
        <div class="title-area" id="modal-moving">
            <h2>担当者情報</h2>
        </div>
        <div class="data-area">
            <ul>
                <li class="row">
                    <span class="label">担当者名</span>
                    <span class="content" v-if="dispPlanData && dispPlanData.userModel">{{ makeFullName(dispPlanData.userModel.userLastName, dispPlanData.userModel.userFirstName) }}</span>
                </li>
                <li class="row">
                    <span class="label">担当者電話番号</span>
                    <span class="content" v-if="dispPlanData">{{ dispPlanData.corpTel }}</span>
                </li>
                <li class="row">
                    <span class="label">担当者メールアドレス</span>
                    <span class="content" v-if="dispPlanData">{{ dispPlanData.userModel.email }}</span>
                </li>
                <li class="row">
                    <span class="label">企業名</span>
                    <span class="content" v-if="dispPlanData && dispPlanData.corpModel">{{ dispPlanData.corpModel.corpName }}</span>
                </li>
                <li class="row">
                    <span class="label">支店・営業所名</span>
                    <span class="content" v-if="dispPlanData && dispPlanData.userModel && dispPlanData.userModel.userDepartment">{{ dispPlanData.userModel.userDepartment }}</span>
                </li>
                <li class="row">
                    <span class="label">担当実績</span>
                    <span class="content">{{ 'テスト' }}</span>
                </li>
                <li class="row">
                    <span class="label">現在の案件担当数</span>
                    <span class="content">{{ 'テスト' }}</span>
                </li>
            </ul>
        </div>
        <div class="modal-footer">
            <button class="main_btn" @click="close()">×</button>
        </div>
    </div>
    </div>
</template>
<script>
export default {
  name: 'SketchPersonModal',
  data () {
    return {
      modalShown: false,
      dispPlanData: null
    }
  },
  watch: {
  },
  methods: {
    showModal: function (dispPlanData) {
      this.dispPlanData = dispPlanData
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    // フルネームを作成
    makeFullName: function (lastName, firstName) {
      return lastName + firstName
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  position: fixed
}

li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .error_message{
    padding: 0px;
    width: auto;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
.row {
  display: flex;
  justify-content: start;
  margin-left: 65px;
  margin-bottom: 30px;
}
.content {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchPersonModal.vue